module.exports = __webpack_public_path__ + "media/images/U-40-only-dfffc5f3493279f0bc10ec83ac2b51d2.svg";